import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initializeLanguageDetection } from './locationDetector';

// Import translation files
import enTranslations from './locales/en.json';
import nlTranslations from './locales/nl.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import esTranslations from './locales/es.json';
import itTranslations from './locales/it.json';
import ptTranslations from './locales/pt.json';

const resources = {
  en: { translation: enTranslations },
  nl: { translation: nlTranslations },
  fr: { translation: frTranslations },
  de: { translation: deTranslations },
  es: { translation: esTranslations },
  it: { translation: itTranslations },
  pt: { translation: ptTranslations },
};

i18n
  .use(LanguageDetector) // Detect user language from browser
  .use(initReactI18next) // Pass i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // Default language
    supportedLngs: ['en', 'nl', 'fr', 'de', 'es', 'it', 'pt'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      // Order of language detection
      // 1. localStorage (user preference)
      // 2. navigator (browser language)
      // 3. htmlTag (HTML lang attribute)
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      
      // Enhanced detection options
      checkWhitelist: true, // Only use supported languages
    },
  })
  .then(() => {
    // After i18n is initialized, enhance with location-based detection
    // This runs asynchronously and won't block the app
    initializeLanguageDetection(i18n).catch(err => {
      console.warn('Location-based language detection failed:', err);
    });
  });

export default i18n;

